import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { fDateTime } from "src/utils/formatTime";
import Iconify from "../iconify";

export const getStatusName = (status) => {
  switch (status) {
    case 0:
      return "Draft";
    case 1:
      return "Active";
    case 2:
      return "Inactive";
    default:
      return "Unknown";
  }
};

export const getEarnModeName = (earnMode) => {
  switch (earnMode) {
    case 0:
      return "Coin Bundle";
    case 1:
      return "Amount";
    default:
      return "Unknown";
  }
};

export const getPhaseName = (phase) => {
  switch (phase) {
    case "Upcoming":
      return "Upcoming";
    case "Collecting":
      return "Collecting hammers";
    case "AwaitingDraw":
      return "Awaiting draw";
    case "AwaitingSmash":
      return "Drawn, smash not open";
    case "Smashing":
      return "Smashing";
    case "Ended":
      return "Ended";
    default:
      return "-";
  }
};

export default function HammerSmashTable(props) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const handleMenuOpen = (event, campaign) => {
    setAnchorEl(event.currentTarget);
    setSelectedCampaign(campaign);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedCampaign(null);
  };

  const handleEdit = () => {
    if (selectedCampaign) {
      navigate(
        `/dashboard/hammer-smash/campaign?campaign_id=${selectedCampaign.campaignId}`
      );
    }
    handleMenuClose();
  };

  const handleParticipants = () => {
    if (selectedCampaign) {
      navigate(`/dashboard/hammer-smash/${selectedCampaign.campaignId}/participants`);
    }
    handleMenuClose();
  };

  const handleDelete = () => {
    if (selectedCampaign && props.onDelete) {
      props.onDelete(selectedCampaign);
    }
    handleMenuClose();
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="hammer smash table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Title</TableCell>
            <TableCell>Earn Mode</TableCell>
            <TableCell>Hammers / Redemption</TableCell>
            <TableCell>Max Redemptions</TableCell>
            <TableCell>Hammers Issued</TableCell>
            <TableCell>Promo Period</TableCell>
            <TableCell>Draw Date</TableCell>
            <TableCell>Smash Period</TableCell>
            <TableCell>Phase</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Winner</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.campaigns?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.campaignId}
              </TableCell>
              <TableCell>{row.title}</TableCell>
              <TableCell>
                {getEarnModeName(row.earnMode)}
                {row.earnMode === 1 && row.spendThreshold ? ` ($${row.spendThreshold})` : ""}
              </TableCell>
              <TableCell>{row.hammersPerRedemption}</TableCell>
              <TableCell>{row.maxRedemptions}</TableCell>
              <TableCell>{row.hammersCount}</TableCell>
              <TableCell>
                {fDateTime(row.promoStartDate)} - {fDateTime(row.promoEndDate)}
              </TableCell>
              <TableCell>{fDateTime(row.drawDate)}</TableCell>
              <TableCell>
                {fDateTime(row.smashStartDate)} - {fDateTime(row.smashEndDate)}
              </TableCell>
              <TableCell>{getPhaseName(row.phase)}</TableCell>
              <TableCell>{getStatusName(row.status)}</TableCell>
              <TableCell>
                {row.drawnAt ? row.winnerUsername || "No entries" : "-"}
              </TableCell>
              <TableCell>
                <IconButton
                  onClick={(event) => handleMenuOpen(event, row)}
                  size="small"
                >
                  <Iconify icon="eva:more-vertical-fill" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEdit}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 1 }} />
          Edit
        </MenuItem>
        <MenuItem onClick={handleParticipants}>
          <Iconify icon="eva:people-fill" sx={{ mr: 1 }} />
          Participants
        </MenuItem>
        <MenuItem
          onClick={handleDelete}
          disabled={selectedCampaign?.status !== 0 || selectedCampaign?.hammersCount > 0}
        >
          <Iconify icon="eva:trash-2-fill" sx={{ mr: 1 }} />
          Delete
        </MenuItem>
      </Menu>
    </TableContainer>
  );
}
